export const initialValues = {
    CPFCNPJ: "",
    RazaoSocial: "",
    NomeFantasia: "",
    Setor: "",
    SubSetor: "",
    TipoCadastro: "MATRIZ",
    PeriodicidadeBalanco: "",
    MesFechamento: "12",
    EGEM: null,
    EFRF: null,
    GrupoEconomico_Nome: "",
    GrupoEconomico_RaizCNPJ: "",
    Site_RI: "",
    Atividade: "",
    Observacao: "",
    GrupoAuditoria: "",
    GrupoCustodiante: "",
    GrupoCoordenadorLider: "",
    GrupoFiduciario: "",
    GrupoIFRecebedora: "",
    GrupoSecuritizador: "",
}

export const toBooleanOrNull = (value) => {
    if (value === "true") return true
    if (value === "false") return false
    return null
}

export const getBooleanSelectValue = (value) => typeof value === "boolean" ? String(value) : ""

export const booleanOptions = [
    { value: "true", label: "Sim" },
    { value: "false", label: "Não" },
]

export const groupFields = [
    { name: "GrupoAuditoria", label: "Grupo Auditoria" },
    { name: "GrupoCustodiante", label: "Grupo Custodiante" },
    { name: "GrupoCoordenadorLider", label: "Grupo Coordenador Líder" },
    { name: "GrupoFiduciario", label: "Grupo Fiduciário" },
    { name: "GrupoIFRecebedora", label: "Grupo IF Recebedora" },
    { name: "GrupoSecuritizador", label: "Grupo Securitizador" },
]
